import { ax } from "src/common/api/apiClient";

export const fetchWrapper = {
  get,
  post,
  put,
  delete: _delete,
};

function get(API_ENDPOINT: any) {
  return ax.get(API_ENDPOINT).then(handleResponse);
  // .catch(handleErrorResponse);
}

function post(API_ENDPOINT: any, body: any) {
  return ax.post(API_ENDPOINT, body).then(handleResponse);
}

function put(API_ENDPOINT: any, body: any) {
  return ax.put(API_ENDPOINT, body).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(API_ENDPOINT: any) {
  return ax.delete(API_ENDPOINT).then(handleResponse);
}
// helper functions
function handleResponse(response: any) {
  return response.data;
}
